// src/icons/PlayFilledIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function PlayFilledIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M20.6432 11.152C21.2699 11.5437 21.2699 12.4563 20.6432 12.848L7.53 21.0437C6.86395 21.46 6 20.9812 6 20.1957L6 3.80424C6 3.01881 6.86395 2.53996 7.53 2.95624L20.6432 11.152Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  PlayFilledIcon
};
//# sourceMappingURL=PlayFilledIcon.mjs.map